import { render, staticRenderFns } from "./ShippingCompanyPopup.vue?vue&type=template&id=44960c9a&scoped=true"
import script from "./ShippingCompanyPopup.vue?vue&type=script&lang=js"
export * from "./ShippingCompanyPopup.vue?vue&type=script&lang=js"
import style0 from "./ShippingCompanyPopup.vue?vue&type=style&index=0&id=44960c9a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44960c9a",
  null
  
)

export default component.exports